export default "__VITE_ASSET__Ef0QyA6G__"